// src/components/gavion/i18n/modules/privacy.en.ts
export const privacyEn = {
  title: "Privacy",
  officer: {
    title: "Person in charge of the protection of personal information",
    name: "Name",
    email: "Email",
    hint: "Shown in the email footer and on the unsubscribe page (Law 25).",
    invalid_email: "Invalid email.",
  },
  retention: {
    title: "Retention",
    recording_days: "Call recordings (days)",
    transcript_days: "Meeting transcripts (days)",
    audit_days: "Audit log (days)",
    range: "Between %{min} and %{max} days.",
    fixed:
      "Fixed: processed automation events 90 days, non-customer email snippets 3 years, export archives 24 h, phone suppressions 3 years, email and erasure suppressions forever.",
  },
  save: "Save",
  saved: "Settings saved.",
  search: {
    label: "Company or person",
    placeholder: "Name, email or phone",
    button: "Search",
    none: "No results.",
    select: "Select",
    selected: "Selected: %{name}",
    contacts: "%{smart_count} contact |||| %{smart_count} contacts",
    via_contact: "via contact %{name}",
    help: "Searches the name, email or phone of the company and its contacts. A contact without a company is not found: export and erasure act on a whole company.",
  },
  export: {
    title: "Export a person's data",
    hint: "Builds a ZIP archive with all linked data (access request, Law 25). The action is logged.",
    button: "Export",
    running: "Building the archive…",
    ready: "Archive ready: %{files} files attached, %{missing} not found.",
    download: "Download the archive",
    expires: "Link valid until %{date}.",
  },
  erase: {
    title: "Erase a person",
    hint: "Deletes or anonymises all data of the company and its contacts. Irreversible.",
    button: "Erase…",
    dialog_title: "Permanently erase “%{name}”",
    warning:
      "This cannot be undone. The person's phone numbers and emails stay on the suppression list so they are never contacted again.",
    reason: "Reason",
    reasons: {
      person_request: "Request from the person",
      cai_order: "Order from the Commission d'accès à l'information",
      other: "Other",
    },
    ack: "I understand this cannot be undone.",
    confirm_label: "Type the exact company name to confirm",
    confirm: "Erase permanently",
    cancel: "Cancel",
    done: "Erasure complete.",
    counts: "Rows processed",
    purge:
      "%{smart_count} file will be deleted from storage tonight. |||| %{smart_count} files will be deleted from storage tonight.",
    residual:
      "Warning: %{smart_count} column still contains a value of the person. Check before closing the request. |||| Warning: %{smart_count} columns still contain a value of the person. Check before closing the request.",
    residual_unknown:
      "Erasure done, but residuals unknown: the check for remaining data failed. Do not treat the request as closed; contact support.",
  },
  audit: {
    title: "Audit log",
    action: "Action",
    all_actions: "All actions",
    at: "Date",
    actor: "By",
    entity: "Object",
    system: "System",
    empty: "No entries.",
    previous: "Previous",
    next: "Next",
    page: "Page %{page} of %{pages}",
    actions: {
      erasure_person: "Person erased",
      erasure_residual: "Post-erasure check",
      export_person: "Person exported",
      settings_update: "Settings changed",
      recording_play: "Recording played",
      user_invite: "Invitation",
      user_role_change: "Role change",
      user_disable: "User disabled",
      suppression_remove: "Suppression removed",
      api_key_create: "API key created",
      api_key_revoke: "API key revoked",
      campaign_schedule: "Campaign scheduled",
      campaign_cancel: "Campaign cancelled",
      export_report: "Report exported",
    },
  },
  errors: {
    forbidden: "Access denied: admins only.",
    not_found: "Company not found.",
    already_erased: "This company was already erased.",
    confirmation_mismatch: "The typed name does not match.",
    invalid_reason: "Invalid reason.",
    invalid_email: "Invalid email.",
    out_of_range: "Value out of range.",
    not_integer: "Enter a whole number.",
    export_too_large: "The archive is over 60 MB. Contact technical support.",
    query_too_short: "Type at least 2 characters.",
    export_failed:
      "The export failed. Try again; if it happens again, contact technical support.",
    unauthorized: "Your session expired. Sign in again, then retry.",
    invalid_body: "Invalid request. Reload the page, then try again.",
    method_not_allowed:
      "The server refused the request. Reload the page, then try again.",
    network: "Cannot reach the server. Check your connection and try again.",
    unknown: "Unexpected error (code: %{code}).",
  },
};
